import React, { useState } from "react";
import { Tabs } from '@veneer/core';

const UserNotRegistered = () =>{
    
    const [viewactivetab, setviewactivetab] = useState(0);

    return (
        <div>
            <Tabs
                controlId="default"
                onChangeTab={(index) => {setviewactivetab(index);}}
                selectedTabId={viewactivetab}
                tabs={[
                    { id: 0, label: 'English (US)', content: <div style={{ padding: '20px' }}>
                        <h4>Your email address is not registered in iPSP. To request access, please send an email to <a href="mailto:ipsp@hp.com?subject=Access%20Request">ipsp@hp.com</a></h4>
                    </div> },
                    { id: 1, label: 'Español (ES)', content: <div style={{ padding: '20px' }}>
                        <h4>Tu dirección de correo electrónico no está registrada en iPSP. Para solicitar acceso, por favor envía un correo a <a href="mailto:ipsp@hp.com?subject=Access%20Request">ipsp@hp.com</a></h4>
                    </div> },
                    { id: 2, label: 'Português (BR)', content: <div style={{ padding: '20px' }}>
                        <h4>Seu endereço de e-mail não está registrado no iPSP. Para solicitar acesso, envie um e-mail para <a href="mailto:ipsp@hp.com?subject=Access%20Request">ipsp@hp.com</a></h4>
                    </div> },
                ]}
            />
        </div>
    );
}

export default UserNotRegistered;